export const StartPageVersions = {
    Circle: 'circle',
    Cards: 'cards',
    None: 'none',
} as const;
